import { Loader } from "@googlemaps/js-api-loader";
import {devices, sizes, isBeforeOrEqualDevice} from './config';

const API_KEY_MAP = 'AIzaSyDiAecSzLZbZnx_Xg_PU-4oofqHDcTXK1g';

const loader = new Loader({
    apiKey: API_KEY_MAP,
    version: "weekly",
});


const dpi = { lat: 47.22694609261111, lng: -0.11787018582779822 };
const saumur = { lat: 47.260135, lng: -0.080893 };

const zoomHome = (!isBeforeOrEqualDevice(devices.SM))  ? 10 : 8;

export function initMapContact() {
    loader.load().then(() => {

        const styledMapType = new google.maps.StyledMapType(
            [
                {
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#f5f5f5"
                        }
                    ]
                },
                {
                    "elementType": "labels.icon",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#616161"
                        }
                    ]
                },
                {
                    "elementType": "labels.text.stroke",
                    "stylers": [
                        {
                            "color": "#f5f5f5"
                        }
                    ]
                },
                {
                    "featureType": "administrative.land_parcel",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#bdbdbd"
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#eeeeee"
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#757575"
                        }
                    ]
                },
                {
                    "featureType": "poi.park",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#e5e5e5"
                        }
                    ]
                },
                {
                    "featureType": "poi.park",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#9e9e9e"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#ffffff"
                        }
                    ]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#757575"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#dadada"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#616161"
                        }
                    ]
                },
                {
                    "featureType": "road.local",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#9e9e9e"
                        }
                    ]
                },
                {
                    "featureType": "transit.line",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#e5e5e5"
                        }
                    ]
                },
                {
                    "featureType": "transit.station",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#eeeeee"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#c9c9c9"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#9e9e9e"
                        }
                    ]
                },
                { name: "Styled Map" }
            ]
        );

        const map = new google.maps.Map(document.getElementById("jsMapContact"), {
            center: dpi,
            zoom: 17,
            mapTypeControlOptions: {
                mapTypeIds: ["roadmap", "satellite", "hybrid", "terrain", "styled_map"],
            },
        });
        map.mapTypes.set("styled_map", styledMapType);
        map.setMapTypeId("styled_map");

        const marker = new google.maps.Marker({
            position: dpi,
            map: map,
            icon:'/wp-content/themes/dpi/images/icons/pin.png'
        });
    });
}

export function initMapHome() {
    loader.load().then(() => {
        const map = new google.maps.Map(document.getElementById("jsMapIntervention"), {
            center: saumur,
            zoom: zoomHome,
        });

        const marker = new google.maps.Marker({
            position: saumur,
        });

// Add circle overlay and bind to marker
        const circle = new google.maps.Circle({
            map: map,
            radius: 33000,
            strokeColor: "#03A9F4",
            strokeOpacity: 0.5,
            strokeWeight: 2,
            fillColor: "#03A9F4",
            fillOpacity: 0.2,
        });
        circle.bindTo('center', marker, 'position');
    });
}
